exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#pages-core-footer a{color:#fff;font-size:.825rem;font-weight:500;text-decoration:none;text-transform:uppercase}", ""]);

// exports
